import { useState } from 'react';

import { IconSelect, TacticsIds } from './icons';

import { Button } from '@/components';
import { Maybe } from '@/types';
import { cn, focusClass, TACTICS_ARR, tacticToString } from '@/utils';

type Props = {
  fieldSelectedTactic: number;
  onSubmit: (tacticId: number) => void;
};

export function TacticPicker({ fieldSelectedTactic, onSubmit }: Props) {
  const [selectedTactic, setSelectedTactic] = useState<Maybe<TacticsIds>>(null);

  return (
    <div className="space-y-[1.44rem]">
      <header>
        <h1 className="text-base text-black font-semibold text-center">
          Cambio de táctica
        </h1>
      </header>
      <section className="grid grid-cols-3 gap-[0.92rem] px-5 lg:px-0">
        {TACTICS_ARR.map((_t, i) => {
          if (i > 0) {
            const isDisabled = i === (fieldSelectedTactic as TacticsIds);
            const index = i as TacticsIds;
            const tacticVal = tacticToString(i);

            if (tacticVal) {
              return (
                <button
                  key={`tactic-picker-btn-${i}`}
                  className={cn(
                    'rounded-[0.67rem] py-[1rem] bg-white border-[2px] border-gdt-blue-xl2 hover:border-gdt-blue transition-all space-y-[0.5rem]',
                    focusClass,
                    {
                      'border-gdt-blue bg-[#E3EAFF]': i === selectedTactic,
                      'opacity-50 border-gdt-blue-xl2 bg-white hover:border-gdt-blue-xl2 cursor-not-allowed':
                        isDisabled,
                    }
                  )}
                  disabled={isDisabled}
                  onClick={() => {
                    setSelectedTactic(index);
                  }}
                >
                  <p
                    className={cn('text-base lg:text-sm font-bold text-black', {
                      'text-gdt-blue': i === selectedTactic,
                      'text-black': isDisabled,
                    })}
                  >
                    {tacticVal.replaceAll(',', '-')}
                  </p>
                  <div className="flex justify-center">
                    <IconSelect id={index} />
                  </div>
                </button>
              );
            }

            return null;
          }

          return null;
        })}
      </section>
      <footer className="flex justify-center">
        <Button
          className="w-full lg:max-w-[16rem] py-[0.813rem] lg:py-[0.563rem]"
          disabled={!selectedTactic}
          type="button"
          variant="primary"
          onClick={() => onSubmit(selectedTactic as number)}
        >
          Continuar
        </Button>
      </footer>
    </div>
  );
}
